import styled from 'styled-components'

export const IdLink = styled.div`
  position: absolute;
  top: -200px;
`
